/*
Already edited, custom to app
*/
import { DiamondIcon, DiamondsFourIcon, StarFourIcon } from "@phosphor-icons/react/dist/ssr"
import type { TPricingPlan } from "@/app/(app)/app/subscribe/types"
import { Entitlement } from "@/lib/polar/types"

export type TPricingPlansConfig = Record<Entitlement, TPricingPlan>

export const pricingPlansConfig: TPricingPlansConfig = {
  [Entitlement.PRO]: {
    entitlement: Entitlement.PRO,
    name: "Pricing.plans.pro.name",
    description: "Pricing.plans.pro.description",
    icon: DiamondsFourIcon,
    features: [
      { feature: "Pricing.features.ai-personalized-messages" },
      { feature: "Pricing.features.link-prospecting" },
      { feature: "Pricing.features.contact-discovery" },
      { feature: "Pricing.features.limit-seats" },
    ],
  },
  [Entitlement.ULTRA]: {
    entitlement: Entitlement.ULTRA,
    name: "Pricing.plans.ultra.name",
    description: "Pricing.plans.ultra.description",
    icon: DiamondIcon,
    features: [
      { feature: "Pricing.features.ai-personalized-messages" },
      { feature: "Pricing.features.link-prospecting" },
      { feature: "Pricing.features.contact-discovery" },
      { feature: "Pricing.features.limit-seats" },
      { feature: "Pricing.features.linkedin-integration", isComingSoon: true },
      { feature: "Pricing.features.mcp-server", isComingSoon: true },
    ],
    isPopular: true,
  },
  [Entitlement.ENTERPRISE]: {
    entitlement: Entitlement.ENTERPRISE,
    name: "Pricing.plans.enterprise.name",
    description: "Pricing.plans.enterprise.description",
    icon: StarFourIcon,
    features: [
      { feature: "Pricing.features.everything-in-ultra" },
      { feature: "Pricing.features.unlimited-everything" },
      { feature: "Pricing.features.priority-founder-support" },
      { feature: "Pricing.features.custom-integrations" },
      { feature: "Pricing.features.api-access" },
      { feature: "Pricing.features.feature-requests" },
    ],
  },
} as const
